import { Directive } from '@angular/core';

@Directive({
    selector: '[pPagePrimaryActionsDef]',
})
export class PagePrimaryActionsDefDirective {}
